<template>
  <div>
    <div v-if="$store.getters.hasPerm('can_manage_elections')" class="row p-4">
      <div class="col-12">
        <h1 class="mb-4">{{ $t("closing.title") }}</h1>
        <ElectionsStatement :items="items" :model="model" :loading="loading" @loadData="loadData" />
      </div>
    </div>
  </div>
</template>

<script>
import ElectionsStatement from "@/components/ElectionsStatement.vue"

export default {
  components: {
    ElectionsStatement
  },
  data() {
    return {
      items: [],
      model: "",
      loading: false
    }
  },
  created() {
    this.loadData();
  },
    watch: {
      "$route.params": {
        handler: function (val) {
          this.loadData();
        },
        deep: true,
        immediate: true
      }
    },
  methods: {
    loadData() {
      this.loading = true;
      this.$store.getters.api.get('/list').then((response) => {
        this.items = response.data.items;
        this.model = response.data.model;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        if (error.response && error.response.data && error.response.data.error_code) {
          alert(this.$t("error." + error.response.data.error_code));
        }
        else {
          alert(this.$t("error.undefined" + ": " + error));
        }
      });
    },
  }
}
</script>

<style lang="scss">
</style>